import React from 'react';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../SVGIcon';

import styles from './BubbleStepsProgressBar.module.css';

type Props = {
  totalSteps: number;
  currentStep: number;
};

export const BubbleStepsProgressBar: React.FC<Props> = ({
  totalSteps,
  currentStep = 1,
}) => {
  return (
    <div className={styles.progressBar}>
      {Array.from({ length: totalSteps }, (_, index) => (
        <div key={index} className={styles.step}>
          <div
            className={`${styles.line} ${
              index < currentStep ? styles.completed : ''
            }`}
          />
          <div className={`${styles.bubble}`}>
            <SvgIcon
              name={SVGIconType.BubbleIndicator}
              width={24}
              height={24}
              className={`${styles.bubbleIndicator} ${
                index < currentStep
                  ? styles.activeBubble
                  : styles.inactiveBubble
              }`}
            />
            <span
              className={`${styles.stepCount}  ${
                index < currentStep ? styles.activeText : styles.inactiveText
              }`}
            >
              {index + 1}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
